import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getSession({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/findGradeInfoList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getNation({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/dictionary/findAllItemByTypeCode`, {params}).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getProvinceX({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/student/selProvinceByUser`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/student/findProvinceList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getCity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/studentInfoNew/findCityListByProvinceCode`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getArea({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findAreaListByCityCode`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUniversityCity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/studentInfoNew/findCityListByProvinceId`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSubjectList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/university/getSubjectList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getServiceTeacher({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/studentInfoNew/findByOrgIdOfTeacherList`, params).then(response => {
      // axios.get(`/user/findUserByOrgId`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getServiceProductOptions({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getServiceStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getStudentList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/findStudentLst`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  editStudentInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/teacher/student/findStudentLst`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  resetPassword({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/resetStudentPassword`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getStudentInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/getById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  insertStudentAchievement({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/insertStudentAchievement`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  delStudentScore({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/delStudentScore`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  updateStudentAchievementById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/updateStudentAchievementById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  findStudentAchievement({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/findStudentAchievement` + '?studentId=' + params,).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getDepartmentOptions({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/org/findOrgTree`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findStudentNoComplateList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/findStudentNoComplateList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findClassNameNoComplate({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/findClassNameNoComplate`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateStudentxgbServiceComplateByIds({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/updateStudentxgbServiceComplateByIds`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateStudentxgbServiceComplateAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/updateStudentxgbServiceComplateAll`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  searchScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baokao/student/findSchemeInfo`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
